import { INavData } from '@coreui/angular';

export const navItems: INavData[] = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'icon-speedometer',
    badge: {
      variant: 'info',
      text: 'NEW'
    }
  },
  {
    title: true,
    name: 'Components'
  },
  {
    name: 'Customer Details',
    url: '/customer',
    icon: 'icon-user',
  },
  {
    name: 'ORC Advance Ledger',
    url: '/orc-advance-ledger',
    icon: 'icon-bag',
  },
  {
    name: 'PA RTN',
    url: '/customer',
    icon: 'icon-layers',
    children: [
      {
        name: 'Document Print',
        url: '/customer/pa-return-doc-print',
        icon: 'icon-layers'
      },
      {
        name: 'PA RTN Apply',
        url: '/customer/pa-return-apply',
        icon: 'icon-layers'
      }


    ]
  },
  {
    name: 'Registration',
    url: '/registration',
    icon: 'icon-layers',
    children: [
      {
        name: 'Customer',
        url: '/registration/customer',
        icon: 'icon-layers'
      },
      {
        name: 'Promoter',
        url: '/registration/promoter',
        icon: 'icon-layers'
      }

    ]
  },
  {
    name: 'Instalment',
    url: '/base',
    icon: 'icon-puzzle',
    children: [
      {
        name: 'Bulk Instalment Pay',
        url: '/customer/instalment-add-details',
        icon: 'icon-puzzle'
      },
      {
        name: 'Instalment Details',
        url: '/instalment/instalment',
        icon: 'icon-puzzle'
      },
      {
        name: 'DLY Ins Details',
        url: '/instalment/dly-instalment-details',
        icon: 'icon-puzzle'
      },
      {
        name: 'Customer Due Ins',
        url: '/instalment/customer-due-details',
        icon: 'icon-puzzle'
      }
    ]
  },
  {
    name: 'ORC',
    url: '/buttons',
    icon: 'icon-cursor',
    children: [
      {
        name: 'ORC Status',
        url: '/orc/orc-status',
        icon: 'icon-cursor'
      },
      {
        name: 'ORC Report',
        url: '/orc/orc-report',
        icon: 'icon-cursor'
      },
      {
        name: 'Paid ORC',
        url: '/orc/paid-orc',
        icon: 'icon-cursor'
      },
      {
        name: 'Unpaid ORC',
        url: '/orc/unpaid-orc',
        icon: 'icon-cursor'
      },
      {
        name: 'ORC Business Report',
        url: '/orc/orc-business',
        icon: 'icon-cursor'
      },
      {
        name: 'Plotting ORC',
        url: '/orc/plotting-orc',
        icon: 'icon-cursor'
      },
      {
        name: 'Blueheaven ORC',
        url: '/orc/blueheaven-orc',
        icon: 'icon-cursor'
      }
    ]
  },
  {
    name: 'SPOT',
    url: '/icons',
    icon: 'icon-star',
    children: [
      {
        name: 'SPOT Status',
        url: '/spot/spot-status',
        icon: 'icon-star'

      },
      {
        name: 'Paid SPOT',
        url: '/spot/paid-spot',
        icon: 'icon-star'
      },
      {
        name: 'Unpaid SPOT',
        url: '/spot/unpaid-spot',
        icon: 'icon-star'
      }
    ]
  },
  {
    title: true,
    name: 'Account'
  },
  {
    name: 'Accounting',
    url: '/notifications',
    icon: 'icon-bell',
    children: [
      {
        name: 'Account Details',
        url: '/account/account-details',
        icon: 'icon-bell'
      },
      {
        name: 'Advance Report',
        url: '/account/advance-report',
        icon: 'icon-bell'
      },
      {
        name: 'Extra Money',
        url: '/account/extra-money',
        icon: 'icon-bell'
      }
    ]
  },
  {
    name: 'Deduction',
    url: '/icons',
    icon: 'icon-calculator',
    children: [
      {
        name: 'TDR',
        url: '/deduction/tds',
        icon: 'icon-calculator'
      },
      {
        name: 'Safety Fund',
        url: '/deduction/sf',
        icon: 'icon-calculator'
      },
      // {
      //   name: 'Service Charge',
      //   url: '/deduction/service-charge',
      //   icon: 'icon-calculator'
      // },
    ]
  },
  {
    name: 'Chain',
    url: '/icons',
    icon: 'icon-energy',
    children: [
      {
        name: 'Direct Chain',
        url: '/chain/direct-chain',
        icon: 'icon-energy'
      },
      {
        name: 'Team Chain',
        url: '/chain/team-chain',
        icon: 'icon-energy'
      },
      {
        name: 'Promoter Joining',
        url: '/chain/promoter-joining',
        icon: 'icon-energy'
      },
    ]
  },
  {
    name: 'Business',
    url: '/icons',
    icon: 'icon-wallet',
    children: [
      {
        name: 'Promoter Team ',
        url: '/business/promoter-team-business',
        icon: 'icon-wallet'
      },
      {
        name: 'Promoter Short',
        url: '/business/promoter-short-business',
        icon: 'icon-wallet'
      },

    ]
  },
  {
    title: true,
    name: 'Status'
  },
  {
    name: 'Promotion',
    url: '/buttons',
    icon: 'icon-layers',
    children: [
      {
        name: 'Promotion (Current)',
        url: '/promotion',
        icon: 'icon-layers'
      },
      {
        name: 'Promotion (1 Day Before)',
        url: '/promotion/scheduled-promotion',
        icon: 'icon-layers'
      }

    ]
  },
  {
    name: 'MFA',
    url: '/buttons',
    icon: 'icon-layers',
    children: [
      {
        name: 'MFA (Current)',
        url: '/mfa',
        icon: 'icon-layers'
      },
      {
        name: 'MFA (1 Day Before)',
        url: '/mfa/scheduled-mfa',
        icon: 'icon-layers'
      }

    ]
  },
  {
    name: 'Club Member',
    url: '/buttons',
    icon: 'icon-layers',
    children: [
      {
        name: 'Business Club Member',
        url: '/club-member/business-club-member',
        icon: 'icon-layers'
      },
      {
        name: 'Business Champion',
        url: '/club-member/business-champion',
        icon: 'icon-layers'
      },
      {
        name: 'Star Club Member',
        url: '/club-member/star-club-member',
        icon: 'icon-layers'
      },
      {
        name: 'GBM Club Member',
        url: '/club-member/gbm-member-report',
        icon: 'icon-layers'
      }
      ,
      {
        name: 'Death Help Member',
        url: '/club-member/death-help-member',
        icon: 'icon-layers'
      },
      {
        name: 'YEAR OF THE CUSTOMER EXCELLENCE AWARD',
        url: '/club-member/best-self-reward',
        icon: 'icon-layers'
      },
      {
        name: 'Best Self Leadership',
        url: '/club-member/best-self-leadership',
        icon: 'icon-layers'
      }

    ]
  },
  {
    name: 'Development',
    url: '/buttons',
    icon: 'icon-layers',
    children: [
      {
        name: 'Thoughts',
        url: '/sanlord/thought',
        icon: 'icon-layers'
      },
      {
        name: 'Motivation',
        url: '/sanlord/motivation',
        icon: 'icon-layers'
      }

    ]
  },
  {
    title: true,
    name: 'Setting',

  },
  {
    name: 'Profile',
    url: '/buttons',
    icon: 'icon-cursor',
    children: [
      {
        name: 'User Profile',
        url: '/settings/profile',
        icon: 'icon-user'
      },
      {
        name: 'Welcome Letter',
        url: '/settings/welcome-letter',
        icon: 'icon-user'
      },
      {
        name: 'ID Card',
        url: '/settings/id-card',
        icon: 'icon-user'
      },
      {
        name: 'Change Password',
        url: '/settings/change-pwd',
        icon: 'icon-user'
      }
    ]
  },

  {
    name: 'Plan',
    url: '/sanlord/plan',
    icon: 'icon-cursor',
  },
  {
    name: 'Notice Board',
    url: '/sanlord/notice',
    icon: 'icon-cursor',
  },
  {
    name: 'Events',
    url: '/sanlord/events',
    icon: 'icon-cursor',
  },
  {
    name: 'Terms & Condition',
    url: '/sanlord/terms',
    icon: 'icon-cursor',
  },


];
